import React, { useState } from 'react';

interface SearchUserProps {
	makeSearch: (email: string) => void;
}

const SearchUser: React.FC<SearchUserProps> = ({ makeSearch }) => {
	const [searchInput, setSearchInput] = useState<string>('');

	const handleSearchChange = (value: string) => {
		setSearchInput(value);
	};

	return (
		<div className="search-container">
			<input
				className="input-text-search-bar"
				type="text"
				id="search-bar-input"
				autoComplete="off"
				value={searchInput}
				onChange={e => handleSearchChange(e.target.value)}
				placeholder="Search user by email"
			/>
			<div className="admin-panel-search-buttons-box">
				<button
					type="button"
					className="admin-panel-search-button"
					onClick={() => makeSearch(searchInput)}
				>
					Search
				</button>
			</div>
		</div>
	);
};

export default SearchUser;
